var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('s-awards',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAvailable),expression:"isAvailable"}],staticClass:"main-page-awards",attrs:{"large":_vm.content.isLarge,"awards":_vm.list}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }